import { AppBar, Toolbar } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
} from "@websential/cosmic-v20";

import { FC } from "react";

export interface ICRADueRemittanceTransacitonsToolbar {
	onProcessedOnCraWebsiteButtonClickedHandler: () => void
	onDeleteButtonClickedHandler: () => void
	onSaveButtonClickedHandler: () => void
}

export const CRADueRemittanceTransacitonsToolbar: FC<ICRADueRemittanceTransacitonsToolbar> = ({
	onProcessedOnCraWebsiteButtonClickedHandler,
	onDeleteButtonClickedHandler,
	onSaveButtonClickedHandler,
}) => {
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			data-testId={""}
			sx={{
				backgroundColor: "#fff",
				boxShadow: "none",
				alignItems: "center",
				zIndex: 0,
			}}
		>
			<Toolbar>
				<EnhancedButtonPrimeReact
					label="Save"
					onClickHandler={onSaveButtonClickedHandler}
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginRight: "1rem" }}
				/>
				<EnhancedButtonPrimeReact
					label="Processed on CRA websire"
					onClickHandler={onProcessedOnCraWebsiteButtonClickedHandler}
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginRight: "1rem" }}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Delete"
					raised
					onClickHandler={onDeleteButtonClickedHandler}
					style={{ marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
				/>
			</Toolbar>
		</AppBar>
	);
};
